import { createAction } from "@reduxjs/toolkit";
import { DamSchedule } from "src/types/damSchedule";

export const DAM_SCHEDULES_GET_ALL = createAction<{ damSchedules: DamSchedule[] }>("@damSchedules/GET_ALL");
export const DAM_SCHEDULES_GET_BY_ID = createAction<{ damSchedule: DamSchedule }>("@damSchedules/GET_BY_ID");
export const DAM_SCHEDULES_GET_BY_DATE = createAction<{ damSchedules: DamSchedule[] }>("@damSchedules/GET_BY_DATE");
export const DAM_SCHEDULES_ADD = createAction<{ damSchedule: DamSchedule }>("@damSchedules/ADD");
export const DAM_SCHEDULES_UPDATE = createAction<{ damSchedule: DamSchedule }>("@damSchedules/UPDATE");
export const DAM_SCHEDULES_DELETE = createAction<{ damScheduleId: string }>("@damSchedules/DELETE");
